/**
 * Professional Masonry Layout Worklet
 * 
 * Implements a production-grade masonry (Pinterest-style) layout engine.
 * Handles dynamic column counts based on container width and varying item heights.
 */

class MasonryLayout {
  async layout(children: any[], edges: any, constraints: any, styleMap: any) {
    const inlineSize = constraints.fixedInlineSize;
    const columnWidth = parseFloat(styleMap.get('--fluent-masonry-column-width')) || 250;
    const gap = parseFloat(styleMap.get('--fluent-masonry-gap')) || 16;
    
    const columns = Math.max(1, Math.floor((inlineSize + gap) / (columnWidth + gap)));
    const actualWidth = (inlineSize - (columns - 1) * gap) / columns;
    
    // Initialize column heights
    const columnHeights = new Array(columns).fill(0);
    const childFragments: any[] = [];
    
    for (const child of children) {
        // Find shortest column
        const minHeight = Math.min(...columnHeights);
        const columnIndex = columnHeights.indexOf(minHeight);
        
        const fragment = await child.layoutNextFragment({
            fixedInlineSize: actualWidth
        });
        
        fragment.inlineOffset = columnIndex * (actualWidth + gap);
        fragment.blockOffset = minHeight;
        
        columnHeights[columnIndex] += fragment.blockSize + gap;
        childFragments.push(fragment);
    }
    
    const blockSize = Math.max(...columnHeights) - gap;
    return {
        autoBlockSize: blockSize,
        childFragments
    };
  }
}

registerLayout('fluent-masonry', MasonryLayout);
